export let ErrorCategory = /*#__PURE__*/function (ErrorCategory) {
  ErrorCategory["NotFound"] = "NotFound";
  ErrorCategory["NotPermitted"] = "NotPermitted";
  ErrorCategory["MalformedInput"] = "MalformedInput";
  ErrorCategory["Internal"] = "Internal";
  return ErrorCategory;
}({});
export let StatusCode = /*#__PURE__*/function (StatusCode) {
  StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
  StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
  StatusCode[StatusCode["GONE"] = 410] = "GONE";
  StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
  return StatusCode;
}({});
export function isAuthError(error) {
  return isErrorStatusCode(StatusCode.UNAUTHORIZED, error) || isErrorStatusCode(StatusCode.FORBIDDEN, error);
}
export const IGNORED_ERROR_CONSTRUCTORS = ['SentryIgnoreError'];
export const IGNORED_ERROR_MESSAGES = {
  'Could not verify accountId from header': 'AccountIdMismatch'
};
export function ignoredErrorReason(error) {
  const constructor = error === null || error === void 0 ? void 0 : error.constructor.name;
  if (constructor && IGNORED_ERROR_CONSTRUCTORS.includes(constructor)) {
    return constructor;
  }
  const message = (error === null || error === void 0 ? void 0 : error.message) || '';
  const containedReason = message && Object.keys(IGNORED_ERROR_MESSAGES).find(ignoredMessage => message.includes(ignoredMessage));
  if (containedReason) {
    return IGNORED_ERROR_MESSAGES[containedReason];
  }
}
export function isErrorStatusCode(statusCode, error) {
  var _error$message;
  if (!error) {
    return false;
  }
  if (error['status'] === statusCode ||
  // error can be `ProperNetworkError` from `packages/graphql-client/src/links/error.ts`
  error['statusCode'] === statusCode) {
    return true;
  }
  const reg = new RegExp(`status (code)?.*(${statusCode})`);
  return !!(error !== null && error !== void 0 && (_error$message = error.message) !== null && _error$message !== void 0 && _error$message.match(reg));
}
export function is4xxError(error) {
  var _error$message2;
  if (!error) {
    return false;
  }
  const statusCode = error['status'] || error['statusCode'];
  if (parseInt(statusCode, 10) >= 400 && parseInt(statusCode, 10) < 500) {
    return true;
  }
  const reg = new RegExp(/status (code)?.*(4\d\d)/g);
  return !!((_error$message2 = error.message) !== null && _error$message2 !== void 0 && _error$message2.match(reg));
}
export function doesErrorContainStatus(statusCode, message) {
  const reg = new RegExp(`status .*(${statusCode})`);
  return reg.test(message);
}
export let DirectoryErrorCode = /*#__PURE__*/function (DirectoryErrorCode) {
  DirectoryErrorCode["MISSING_ERROR_MESSAGE"] = "MissingErrorMessage";
  return DirectoryErrorCode;
}({});
export let TeamErrorType = /*#__PURE__*/function (TeamErrorType) {
  TeamErrorType["TEAM_NOT_ACTIVE"] = "Team must be active";
  return TeamErrorType;
}({});
export function errorHasProp(error, field) {
  return error instanceof Error && field in error;
}
export function isApolloError(err) {
  return typeof err === 'object' && err !== null && 'graphQLErrors' in err;
}